import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card7 from "../Images/Profiles/Denis.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function DenisMuhangi() {
  return (
    <div className="ne-page">
      <SEO
        title="Dr. Denis Muhangi - Vice Chairman, Executive Council"
        description="Dr. Denis Muhangi is a Veterinarian and Wildlife Pathologist who serves as the Vice Chairman of the Executive Council at CIRCODU. He holds a Doctor of Philosophy Degree from Makerere University, where his research focused on the Epidemiology of African Swine Fever in Uganda. Dr. Muhangi has also been a post-doctoral fellow in the SIDA-Makerere University research collaboration and is a lecturer at the College of Veterinary Medicine, Animal Resources, and Biosecurity (COVAB) at Makerere University."
        keywords="Denis Muhangi, Vice Chairman, Executive Council, CIRCODU, Veterinarian, Wildlife Pathologist, Makerere University, Epidemiology of African Swine Fever, SIDA-Makerere University research collaboration, College of Veterinary Medicine, Animal Resources, Biosecurity"
        url="/denis-muhangi"
        image={Card7}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Dr. Denis Muhangi</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Dr. Denis Muhangi
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card7} alt="Dr. Denis Muhangi" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Dr. Denis Muhangi</h1>
                <p className="profile-card__role">
                  Vice Chairman, Executive Council
                </p>
                <p className="profile-card__sub-role">
                  Veterinarian / Wildlife Pathologist
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Denis earned a Doctor of Philosophy Degree from Makerere
                  University, where his research delved into the Epidemiology of
                  African Swine Fever in Uganda, with a focus on understanding
                  the factors contributing to its persistence.
                </p>
                <p>
                  Between 2016 and 2018, Denis assumed the role of a
                  post-doctoral fellow in the context of the SIDA-Makerere
                  University research collaboration, which spanned from 2015 to
                  2020. During this period, he built upon the foundations laid
                  by his doctoral research. Denis's academic journey also
                  includes the attainment of a Master of Science Degree in
                  Veterinary Pathology and a Bachelor’s Degree in Veterinary
                  Medicine, both of which were conferred upon him by Makerere
                  University.
                </p>
                <p>
                  In addition to his academic pursuits, Denis holds a Lecturing
                  position at the College of Veterinary Medicine, Animal
                  Resources, and Biosecurity (COVAB) at Makerere University. He
                  is an active member of both the Uganda Veterinary Association
                  and the American Association of Zoo Veterinarians (AAZV).
                  Denis takes pride in being an alumnus of Envirovet, an
                  international ecosystem health program tailored for young
                  biologists, veterinarians, and conservationists.
                </p>
                <p>
                  Beyond his affiliations, Denis's research interests span a
                  wide spectrum, including Wildlife Pathology and the study of
                  Wildlife Diseases, encompassing Parasitology, infectious, and
                  noninfectious conditions. In the realm of wildlife pathology,
                  he has participated in and remains engaged in researching the
                  impacts of Oil and Gas activities on fauna in the Albertine
                  Graben, as well as conducting studies on mountain gorillas in
                  collaboration with the Gorilla Doctors program.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/denis-muhangi-69564077/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/mdenis_1234"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/muhangi.denis.3"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256785284996"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:denis.muhangi@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DenisMuhangi;
